import {
    Box,
    Typography,
} from '@mui/material'
import Image from 'next/image'
import WhyApply1 from '../../../assets/why-apply/whyapply1.png'
import WhyApply2 from '../../../assets/why-apply/whyapply2.png'
import WhyApply3 from '../../../assets/why-apply/whyapply3.png'
import WhyApply4 from '../../../assets/why-apply/whyapply4.png'
import { useTranslation } from 'react-i18next'

export const SMAppHomeWhyApply: React.FC = () => {
    const { t } = useTranslation()
    
    const data = [
        {
            'icon': WhyApply1,
            'title': t('t62'),
            'content': t('t63')
        },
        {
            'icon': WhyApply2,
            'title': t('t64'),
            'content': t('t65')
        },
        {
            'icon': WhyApply3,
            'title': t('t66'),
            'content': t('t67')
        },
        {
            'icon': WhyApply4,
            'title': t('t68'),
            'content': t('t69')
        }
    ]
    
    // ======================= StepItem
    const stepItem = (index: number) => {
        return (
            <Box
            key={index}
             sx={{
                flex: '1',
                flexDirection: 'column',
                display: 'flex',
                alignItems: 'center',
                // paddingLeft: '12px',
                // paddingRight: '12px',
                paddingTop: '24px',
            }}>
                <Box sx={{
                    position: 'relative',
                    backgroundColor: '#FFF8E7',
                    marginTop: '40px',
                    width: '100%',
                    height: '100%',
                    maxWidth: '500px',
                    borderRadius: '10px',
                    paddingTop: '55px',
                    paddingBottom: '30px',
                    paddingLeft: '25px',
                    paddingRight: '25px',
                }}>
                    <Typography fontWeight={600} fontSize={'18px'} color={'#141F39'} textAlign={'center'}>
                        {data[index]['title']}
                    </Typography>

                    <Typography paddingTop={'15px'} fontWeight={400} fontSize={'14px'} color={'#6B6B6B'} textAlign={'center'}>
                        {data[index]['content']}
                    </Typography>
                </Box>
                <Box sx={{
                    position: 'absolute',
                    height: '80px',
                }}>
                    <Image src={data[index]['icon']} width={80} height={80} alt=''></Image>
                </Box>
            </Box>
        )
    }

    // ======================= VIEWS
    return (
        <Box>
            <Typography fontSize={24} color={'#141F39'} width={'100%'} textAlign={'center'} paddingTop={'60px'} paddingBottom={'40px'} fontWeight={700}>
                {t('t61')}
            </Typography>

            <Box sx={{
                width: '100%',
                paddingLeft: '12px',
                paddingRight: '12px'
            }}>
                {data.map((item, index) => stepItem(index))}
            </Box>
        </Box>
    )
}

// ======================= EXPORT
export default SMAppHomeWhyApply
